import { render, staticRenderFns } from "./promotion-dialog.vue?vue&type=template&id=45f88a88&scoped=true&"
import script from "./promotion-dialog.vue?vue&type=script&lang=js&"
export * from "./promotion-dialog.vue?vue&type=script&lang=js&"
import style0 from "./promotion-dialog.vue?vue&type=style&index=0&id=45f88a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f88a88",
  null
  
)

export default component.exports